import { render } from "./CreatePatientVisit.Modal.vue?vue&type=template&id=0249d738"
import script from "./CreatePatientVisit.Modal.vue?vue&type=script&lang=js"
export * from "./CreatePatientVisit.Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__